import { createFileRoute } from '@tanstack/react-router'
import { TopicPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/de/community/themen/$topicSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'topic', locale: 'de', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { topicSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <TopicPage topicSlug={topicSlug} />
    </CatalogProvider>
  )
}
